import React from 'react';
import { getLiteral } from 'utils/getLiteral';
import { PAGINATION_TABLE_ENTITY } from 'constants/Environment';
import { BILLBOARD, USERS } from 'constants/Entities';

export default (params) => ({
    pageSize: PAGINATION_TABLE_ENTITY,
    entity: BILLBOARD,
    columnDefs: [
        {
            colId: 'subject',
            headerName: getLiteral('title_billboard_title'),
            field: 'subject',
            headerComponent: 'headerTextCell',
            headerComponentParams: {
                showTotal: true,
            },
            cellRenderer: 'textCell',
            cellRendererParams: {
                bold: true,
            },
            suppressSizeToFit: false,
        },
        {
            colId: 'attachments',
            field: 'attachments',
            headerComponent: 'headerTextCell',
            headerComponentParams: {
                hideTitle: true,
                isSquared: true,
            },
            cellRenderer: 'avatarCell',
            cellRendererParams: {
                align: 'center',
                imageSize: 'small',
                onlyIcon: true,
                innerMethods: {
                    getAvatarSvg: params?.attachments?.getAvatarSvg || null,
                },
            },
            width: 100,
            suppressSizeToFit: true,
        },
        {
            colId: 'userNameCreado',
            headerName: getLiteral('label_billboard_author'),
            field: 'userNameCreado',
            cellRenderer: 'avatarCell',
            cellRendererParams: {
                getUrl: params?.getUrl?.({ idKey: 'userCreado', entity: USERS }) || null,
                otherFields: {
                    src: 'srcAccount',
                    placeholder: 'placeholderAccount',
                },
            },
            suppressSizeToFit: false,
        },
        {
            colId: 'startDate',
            headerName: getLiteral('label_billboard_date_sent'),
            field: 'startDate',
            headerComponent: 'headerTextCell',
            cellRenderer: 'dateCell',
            cellRendererParams: {
                locale: params?.locale?.getLocale() || '',
                outputFormat: 'P',
            },
            width: 150,
            suppressSizeToFit: true,
        },
    ],
});
